export type ViewportType = 'desktop' | 'tablet' | 'mobile';

export function detectViewportType(): ViewportType {
  if (typeof window === 'undefined') return 'desktop';
  const width = window.innerWidth;
  const isTouch = typeof navigator !== 'undefined' && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1;
  const ua = typeof navigator !== 'undefined' ? (navigator.userAgent || '') : '';
  const isMobileUa = /Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const isTabletUa = /iPad|Tablet|PlayBook/i.test(ua);

  if (isMobileUa || width < 768) return 'mobile';
  if (isTabletUa || width <= 1024 || (isTouch && width <= 1200)) return 'tablet';
  return 'desktop';
}

export type DownloadProgressCallback = (progress: {
  /** 0–1 fraction downloaded */
  progress: number;
  /** Human-readable status text */
  text: string;
}) => void;
